module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAICAYAAAAm06XyAAAAAXNSR0IArs4c6QAAAOFJREFUKFNjzNku187IwFjBQCpg/N/JCNKTu0N+GsN/hkzi9f+fOdnzUQZYc0MDA9Nbc/lFDAwM0UQYsFz45MOYhgaGf2DNIJA2k4GVXU5uDQMDox8uA/7//7/l1+NHQbPSGX6D1MA1gzgJ+xU4eH/838bAwOCIbsB/BoYDLz//9Vod9uQ7TA5FM0gwaaMILzcb1x4GBkYzmKL///+f4fr9zanL/81nZEMxNIMks9dJCzNxMR9g+M+ow/Cf4do/tj92U12evkV3DVbNIEU5G2WlGNkYF/5n/h8/xe3xM2zhAABMgkXUcBq+CgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.png
// module id = lP78
// module chunks = 3